import { styled } from '@linaria/react';
import { Link } from 'react-router-dom';

import { center, roboto } from '../stylesheets/shared.css';

export default styled(Link)`
  ${center}
  ${roboto}
  text-transform: uppercase;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
